// extracted by mini-css-extract-plugin
export default {"wrapHeader":"styles_wrapHeader__LAwF+","logo":"styles_logo__irnib"};